module.exports = __webpack_public_path__ + "static/media/header-yandex.153e502a.svg";